// extracted by mini-css-extract-plugin
module.exports = {"Available":"SymbolsCheck_Available__25uB0","Unavailable":"SymbolsCheck_Unavailable__nuRi1"};